import React from 'react';
import { Router, Route, Switch } from 'react-router-dom';
import Home from '../pages/pc/Home/home.js';
import MHome from '../pages/mobile/Home/home.js';
import KnowledgePoint from '../pages/knowledgePoint';
import Exchange from '../pages/Exchange';
import Address from '../pages/Address';
import Task from '../pages/Task/index';
import BlackBoardUpload from '../pages/BlackBoardUpload';
import NotFound from '../pages/notFound/notFound';
import Modal from '../components/Common/Modal';
import history from './history';

class Routers extends React.Component {
    constructor(props) {
        super(props);
    }

    componentDidMount() {
        // router change
        this.unlisten = history.listen(() => {
            Modal.destroyAll();
        });
    }

    componentWillUnmount() {
        this.unlisten && this.unlisten();
    }

    render() {
        return (
            <Router history={history}>
                <Switch>
                    <Route exact path="/" component={Home} />
                    <Route path="/m" component={MHome} />
                    <Route path="/task" component={Task} />
                    <Route path="/exchange" component={Exchange} />
                    <Route path="/address" component={Address}/>
                    <Route path="/knowledge" component={KnowledgePoint} />
                    <Route path="/upload" component={BlackBoardUpload} />
                    <Route component={NotFound}/>
                </Switch>
            </Router>
        );
    }
}


export default Routers;
